// extracted by mini-css-extract-plugin
export default {"Container":"termsAndConditions_Container__mhVLG","termsContent":"termsAndConditions_termsContent__dDIwT"};